module.exports = __webpack_public_path__ + "img/stars-icon.5f296997.svg";